import { ExperienceTemplateRenderer, ExperienceTemplateRendererContextProvider } from 'experience-template-renderer-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { SponsoredPropertiesProvider } from '@shared-ui/retail-lodging-sponsored-properties-carousel';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';

import { CarouselProvider } from 'src/common/stores/contexts/carousel-context-provider';
import { PageLayoutStore } from 'src/common/stores/page-layout/page-layout-store';

import { componentLibrary } from 'components/infosite/template-components';

interface TemplateRendererProps {
  pageLayout?: PageLayoutStore;
}
export const TemplateRenderer: React.FC<TemplateRendererProps> = inject('pageLayout')(
  observer(({ pageLayout }) => (
    <ExperienceTemplateRendererContextProvider library={componentLibrary}>
      <SponsoredPropertiesProvider>
        <CarouselProvider>
          <Viewport>
            <ViewSmall>
              <ExperienceTemplateRenderer
                templateComponents={pageLayout?.getPDPTemplate(`${pageLayout?.templateName}_SMALL`)?.components ?? []}
              />
            </ViewSmall>
            <ViewLarge>
              <ExperienceTemplateRenderer
                templateComponents={pageLayout?.getPDPTemplate(`${pageLayout?.templateName}_LARGE`)?.components ?? []}
              />
            </ViewLarge>
          </Viewport>
        </CarouselProvider>
      </SponsoredPropertiesProvider>
    </ExperienceTemplateRendererContextProvider>
  ))
);
